import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import StudentNotificationsPage from '../../../subsreens/gcstudent/studentnotifications/StudentNotifictaionsPage';

const StudentNotifications = () => {
    return(
        <StudentDashboardLayout>
            <StudentNotificationsPage></StudentNotificationsPage>
        </StudentDashboardLayout>
    )
}

export default StudentNotifications;